<template lang="html">
  <div class="activation-form">
    <h1>Set Password</h1>

    <form @submit.prevent="submit">
      <Field
        label="Password"
        type="password"
        @input="$v.resource.password.$touch()"
        v-model="resource.password"
        :error="passwordError"/>

      <Field
        label="Confirm Password"
        type="password"
        @input="$v.resource.password_confirmation.$touch()"
        v-model="resource.password_confirmation"
        :error="password_confirmationError"/>

      <div class="form-actions">
        <Btn primary :isLoading="btnConfirmLoading">Set Password</Btn>
      </div>
    </form>
  </div>
</template>

<script>
import form from '@/mixins/form'

import {errorMessages} from '@/lib/error_messages'
import {sameAs, required} from 'vuelidate/lib/validators'

import Btn from '@/components/Btn'

export default {
  name: 'AccountActivationForm',

  mixins: [form],

  props: {
    btnConfirmLoading: Boolean
  },

  components: {
    Btn
  },

  computed: {
    ...errorMessages(['password', 'password_confirmation'])
  },

  validations: {
    resource: {
      password: {required},
      password_confirmation: {
        required,
        sameAs: sameAs('password')
      }
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

$activation-form-width: 50%

.activation-form
  margin: auto
  @extend %card
  padding: $gap-x-large
  border-radius: 5px
  max-width: 95%
  width: 100%

  @include media($media-gt-small)
    width: 450px

  h1
    margin: 0 auto $gap-large

  input
    width: 100%

  .form-actions
    text-align: center

    .btn
      display: block
      margin: 0 auto $gap-small
</style>
